/**
 * Detección y flags para previews admin en iframe / nueva pestaña.
 */

import { WORKER_DEBUG_SECRET } from "@/lib/adminGeoPreview";

/** true si la página corre en modo preview admin (iframe o URL de simulación). */
export function isAdminLivePreviewContext(): boolean {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return (
    params.get("_admin_preview") === "1" ||
    Boolean(params.get("_force_variant")?.trim()) ||
    params.get("debug") === WORKER_DEBUG_SECRET
  );
}

/** Preview admin dentro de iframe (country-template, dual CTA). Usa % no dvh. */
export function isAdminEmbeddedPreview(): boolean {
  if (typeof window === "undefined") return false;
  if (!isAdminLivePreviewContext()) return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export const ADMIN_EMBEDDED_PREVIEW_ROOT_CLASS = "admin-embedded-preview";

export const MUX_FULLSCREEN_SHELL_CLASS = "mux-fullscreen-shell";
export const MUX_FULLSCREEN_FRAME_CLASS = "mux-fullscreen-frame";

export const ADMIN_LIVE_PREVIEW_IFRAME_ALLOW =
  "autoplay; fullscreen; encrypted-media; picture-in-picture; web-share";

export const ADMIN_LIVE_PREVIEW_IFRAME_SANDBOX =
  "allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation";

export type AdminPreviewViewportPreset = {
  id: string;
  label: string;
  width: number | "fluid";
};

export const ADMIN_PREVIEW_VIEWPORTS: AdminPreviewViewportPreset[] = [
  { id: "fluid", label: "Fluido", width: "fluid" },
  { id: "320", label: "SE (320)", width: 320 },
  { id: "375", label: "Mobile (375)", width: 375 },
  { id: "390", label: "iPhone (390)", width: 390 },
  { id: "428", label: "Pro Max (428)", width: 428 },
];

/** Altura portrait 9:16 para un ancho dado. */
export function adminPreviewPortraitHeight(widthPx: number): number {
  return Math.round((widthPx * 16) / 9);
}